import { useAuthContext } from "@app/authContext";
import { BASE_URL } from "@services/api";
import { BgFormType } from "@services/guarantees/types";
import { useEffect, useState } from "react";

export type BgCardModelType = {
  productBg: Pick<BgFormType, "guarantee" | "purchase">;
};

interface BGModelI {
  components: BgCardModelType;
}

export const useGetGuaranteeInfo = (id: string) => {
  const { auth } = useAuthContext();
  const access_token = auth?.access_token ?? "";

  const [bgData, setBgData] = useState<BGModelI | null>(null);
  const [loading, setLoading] = useState(true);

  const getGuaranteeModel = async () => {
    const url = `${BASE_URL}/front-bg/card/bg/${id}/model`;

    const r = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${access_token}`,
      },
    });

    if (!r.ok) throw new Error('HTTP ' + r.status);
    const data = await r.json();
    setBgData(data);
    return data;
  };

  useEffect(() => {
    const init = async () => {
      try {
        await getGuaranteeModel();
        setLoading(false);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }

    init();
  }, []);

  return {
    loading,
    bgData,
  };
}
